import React from "react";
import Header from "../components/Frontend/Header";
import Footer from "../components/Frontend/Footer";
import FameWall from "../components/Frontend/FameWall";
import Testimonial from "../components/Frontend/Testimonial";
import VideoTuts from "../components/Frontend/VideoTuts";
import WhyLove from "../components/Frontend/WhyLove";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import ReactGA from "react-ga";
import ReactPixel from "react-facebook-pixel";
import Slider from "react-slick";
class PteStudyMaterial extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isActive: false,
    };
  }
  handleClick = () => {
    this.setState((prevState) => ({
      isActive: !prevState.isActive,
    }));
  };

  componentDidMount() {
    ReactGA.initialize("UA-157984080-1");
    ReactGA.pageview(window.location.pathname + window.location.search);
    
    // ReactPixel.init("197333187452630");
    // ReactPixel.pageView();
  }   
  render() {    
   const customslider = {
    dots: false,
    arrows: false,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
};
    return (
      <React.Fragment>
        <Helmet>
          <title>Top PTE Training Institute Australia | LA Language Academy</title>
          <meta name="description" content="Explore our extensive collection of PTE study material to elevate your preparation. Access PTE material at LA Language Academy today. Contact now!" />
          <meta name="robots" content="index, follow" />
          <link rel="canonical" href={`https://www.languageacademy.com.au/pte-study-material`} />
          <meta name="twitter:card" content="summary_large_image" />
          <meta name="twitter:site" content="@languageacademy" />
          <meta name="twitter:title" content="Top PTE Training Institute Australia | LA Language Academy" />
          <meta name="twitter:description" content="Explore our extensive collection of PTE study material to elevate your preparation. Access PTE material at LA Language Academy today. Contact now!" />
          <meta name="twitter:image" content={`https://www.languageacademy.com.au/images/logol.png`} />
          <meta name="twitter:image:alt" content="LA Language Academy Logo" />
          <meta property="og:url" content={`https://www.languageacademy.com.au/pte-study-material`} />
          <meta property="og:type" content="website" />
          <meta property="og:title" content="Top PTE Training Institute Australia | LA Language Academy" />
          <meta property="og:description" content="Explore our extensive collection of PTE study material to elevate your preparation. Access PTE material at LA Language Academy today. Contact now!" />
          <meta property="og:image" content={`https://www.languageacademy.com.au/images/logol.png`} />
          <meta property="og:image:alt" content="LA Language Academy Logo" />
          <meta property="og:image:width" content="1200" />
          <meta property="og:image:height" content="630" />
        </Helmet>
        <Header />
        <div className="hero-section mt-80 psm-hero-section">
          <div className="container">
            <div className="row">
              <div className="col-lg-8 col-md-8">
                <div className="hero-content">
                  <h1 className="primary-heading mfw-600">
                    Boost your Exam <br className="d-none d-lg-block" /> Preparation with <br className="d-none d-lg-block" /> the Best PTE Study <br className="d-none d-lg-block" /> Material</h1>
                  <p className="sub-heading bold-sub-heading"> 
                    Gauge your performance using the latest
                    <br className="d-none d-md-block" />
                    online PTE practice test material
                  </p>
                  <div className="text-center text-md-start">
                  <Link to="/auth/register" className="primary-btn">REGISTER NOW <img src="/images/web-new-images/right-arrow.svg" alt="LA" /></Link>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-4">
                <div className="hero-img-wrapper">
                  <img
                    className="img-fluid"
                    src="/images/web-new-images/bannerImg.png"
                    alt="LA"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="pte-content-section wrsl-content-section psm-section pt-0">
          <div className="circle-section">
            <div className="container pte-container">
              <div className="row">
                <div className="col-md-12">
                  <div className="position-relative">
                    <ul className="m-0">
                      <li>
                      <span>
                        If you are an aspirant who wants to earn the highest
                        score in Pearson Test of English but due to lack of best
                        PTE study material, not getting the fruitful results
                        then Language Academy is the prime choice for the
                        preparation of PTE course. Here, we are providing
                        offline & online coaching classes for the PTE test
                        preparation to kill the gap between failure and success.
                        Using advanced technology and resources, we always try
                        to satisfy the needs of students to learn something new
                        by opting the best PTE preparation material and
                        methodologies. We know the quality of education which bring us at this level where every aspirant knows our <strong>"Language Academy - PTE Exam Practice Institute"</strong> name. Want to know more about the PTE material online services then you can make a purchasing decision after reviewing the mentioned?
                      </span>
                      </li>
                    </ul>                   
                  </div>
                  <div className="pte-bottom-content">
                    <div>
                      <div onClick={this.handleClick} className="pte-bottom-header d-flex justify-content-center align-items-center">
                        <h3 className="m-0">
                          <a href="javascript:void(0)" className="text-decoration-none">
                            Read More
                          </a>
                        </h3>
                        <img
                          src="/images/web-new-images/icons/bottom-arrow-01.png"
                          alt="LA"
                        />
                      </div>
                      <ul className={`hide-content ${this.state.isActive ? "active" : ""}`}>                     
                        <li>
                          <h4 className="pte-bottom-heading">Why people choose Language Academy for their PTE exam material?</h4>
                        Our best trainers design and build the PTE preparation course bundle in such a way that a beginner can also start with it.
                        </li>
                        <li>
                        In our PTE practice material, you will get all the previous exam repeated material.
                        </li>
                        <li>
                        PTE practice online modules are properly structured like the original ones and the student feels like a real environment.
                        </li>
                        <li>
                        After taking any of PTE online test, student can easily see their response and check the correct answers for the available sections.
                        </li>
                        <li>
                        Apart from the score report, a student can ask their queries from the Pearson PTE practice test online instructor.
                        </li>
                        <li>
                        Our intensive and latest practice material is updated every month, so that you are aware of all the changes and new exam questions.
                        </li>
                        <li>
                        <span>If you have any doubts regarding the PTE practise test and material, you can mail us at <a href="mailto:info@languageacademy.com.au" target="blank">info@languageacademy.com.au</a></span>
                        </li>                       
                      </ul>
                    </div>
                  </div>
                </div>
                <div className="text-center">
                <Link to="/auth/register" className="primary-btn">REGISTER NOW <img src="/images/web-new-images/right-arrow.svg" alt="LA" /></Link>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="goals-section psm-why-choose">
          <div className="container">
            <div className="row">
              <h2 className="primary-heading position-relative text-center">
              Why people choose <br className="d-block" /> Language Academy
              <br className="d-block" />
               for their <span className="wpl-badge pte-naati-badge text-white">PTE exam material?</span>
              </h2>
            </div>
            <div className="single-language-card">                 
              <div className="language-cards position-relative">
                <img
                  className="emoji-icon3"
                  src="/images/web-new-images/emojis/emoji-4.png"
                  alt="LA"
                />
                <img
                  className="emoji-icon2"
                  src="/images/web-new-images/emojis/emoji-1.png"
                  alt="LA"
                />
                <div className="position-relative mt-0">                  
                  <div className="language-card">
                    <ul className="p-0 m-0">
                      <li className="tick-list-item">
                        <h3>
                          <img
                            src="/images/web-new-images/icons/check-icon-01.svg"
                            alt="LA"
                          />{" "}
                           Our best trainers design and build the PTE preparation course bundle in such a way that
                           a beginner can also start with it.
                        </h3>
                      </li>
                      <li className="tick-list-item">
                        <h3>
                          <img
                            src="/images/web-new-images/icons/check-icon-01.svg"
                            alt="LA"
                          />
                          After taking any of PTE online test, student can easily see their response and check the correct answers for the available sections.
                        </h3>
                      </li>
                      <li className="tick-list-item">
                        <h3>
                          <img
                            src="/images/web-new-images/icons/check-icon-01.svg"
                            alt="LA"
                          />{" "}
                          In our PTE practice material, you will get all the previous exam repeated material.
                        </h3>                        
                      </li>
                      <li className="tick-list-item">
                        <h3>
                          <img
                            src="/images/web-new-images/icons/check-icon-01.svg"
                            alt="LA"
                          />{" "}
                          Apart from the score report, a student can ask their queries from the Pearson PTE practice test online instructor.
                        </h3>
                      </li>
                      <li className="tick-list-item">
                        <h3>
                          <img
                            src="/images/web-new-images/icons/check-icon-01.svg"
                            alt="LA"
                          />{" "}
                          PTE practice online modules are properly structured like the original ones and the student feels like a real environment.
                        </h3>
                      </li>
                      <li className="tick-list-item">
                        <h3>
                          <img
                            src="/images/web-new-images/icons/check-icon-01.svg"
                            alt="LA"
                          />{" "}
                          Our intensive and latest practice material is updated every month, so that you are aware of all the changes and new exam questions.
                        </h3>
                      </li>
                    </ul>
                    <div className="psm-why-choose-info">
                        <p>*For any inquiries, please contact us via email:
                           <a href="mailto:info@languageacademy.com.au">info@languageacademy.com.au</a>
                        </p>
                        <div>
                        <Link to="/pte-mock-test" className="dark-border primary-btn">
                          CHECK OUT OUR PTE MOCK TEST <img src="/images/web-new-images/right-arrow.svg" alt="LA" />
                        </Link>
                        </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>      
        <div className="exam-pattern-section pte-exam-pattern pcs-exam-pattern py-0">
          <div className="container">
            <div className="row">
            <h2 className="primary-heading text-center">
            Why People Love <br className='d-block' /><span className="wpl-badge pte-naati-badge text-white">Language Academy</span></h2> 
            <p className="sub-heading text-center">
            We provide the top-rated PTE training to the candidates <br className='d-none d-md-block' /> to make their career journey smooth
            </p>
            <div className="pattern-cards-outer mb-0">  
              <div className="exam-pattern-cards position-relative">                
                <Slider {...customslider}>
                  <div className="exam-pattern-card">
                    <div className="img-wrapper">
                      <img
                        src="/images/web-new-images/icons/speaking-icon.svg"
                        alt="LA"
                      />
                    </div>
                    <h3 className="card-title">Experienced Trainer
                    </h3>
                    <p>We have Pearson certified faculty members...
                    </p>                      
                  </div>
                  <div className="exam-pattern-card">
                    <div className="img-wrapper">
                      <img
                        src="/images/web-new-images/icons/speaking-icon.svg"
                        alt="LA"
                      />
                    </div>
                    <h3 className="card-title">Highest Success Rate</h3>
                    <p>Students will get a sure-shot success with the high...
                    </p>                      
                  </div>
                  <div className="exam-pattern-card">
                      <div className="img-wrapper">
                        <img
                          src="/images/web-new-images/icons/speaking-icon.svg"
                          alt="LA"
                        />
                      </div>
                      <h3 className="card-title">Free Books</h3>
                      <p>Our PTE / NAATI training institute provides free books...
                      </p>                      
                  </div>             
                  <div className="exam-pattern-card">
                    <div className="img-wrapper">
                      <img
                        src="/images/web-new-images/icons/speaking-icon.svg"
                        alt="LA"
                      />
                    </div>
                    <h3 className="card-title">Latest Resources</h3>
                    <p>Making use of the latest technology, we provide...
                    </p>                      
                  </div>                
                  <div className="exam-pattern-card">
                    <div className="img-wrapper">
                      <img
                        src="/images/web-new-images/icons/speaking-icon.svg"
                        alt="LA"
                      />
                    </div>
                    <h3 className="card-title">Online Support</h3>
                    <p>Our experts are always there to help the students through...
                    </p>                      
                  </div>              
                  <div className="exam-pattern-card">
                    <div className="img-wrapper">
                      <img
                        src="/images/web-new-images/icons/speaking-icon.svg"
                        alt="LA"
                      />
                    </div>
                    <h3 className="card-title">3500 + Questions to Practice</h3>
                    <p>We give the students various exercises and practice
                    </p>                      
                  </div>               
                  <div className="exam-pattern-card">
                    <div className="img-wrapper">
                      <img
                        src="/images/web-new-images/icons/speaking-icon.svg"
                        alt="LA"
                      />
                    </div>
                    <h3 className="card-title">Discussion Sessions</h3>
                    <p>During the discussion sessions, Our experienced team...
                    </p>                      
                  </div>               
                  <div className="exam-pattern-card">
                    <div className="img-wrapper">
                      <img
                        src="/images/web-new-images/icons/speaking-icon.svg"
                        alt="LA"
                      />
                    </div>
                    <h3 className="card-title">Affordable Fees</h3>
                    <p>We offer the best PTE and NAATI coaching classNamees...
                    </p>                      
                  </div>               
                  <div className="exam-pattern-card">
                    <div className="img-wrapper">
                      <img
                        src="/images/web-new-images/icons/speaking-icon.svg"
                        alt="LA"
                      />
                    </div>
                    <h3 className="card-title">Real Time Test Environment</h3>
                    <p>We provide several mock tests for reading, listening...
                    </p>                      
                  </div>                                  
                </Slider>
              </div>
              <div className="text-center">
                <Link to="/auth/register" className="dark-border primary-btn">
                REGISTER NOW <img src="/images/web-new-images/right-arrow.svg" alt="Register Now" />
                </Link>
              </div>
            </div>
            </div>
          </div>
        </div> 
        <Testimonial />
        <VideoTuts />
        <div className="faq-section mt-faq">
            <div className="container">
              <div className="row">
                <h2 className="secondary-heading text-center">
                  Frequently Asked Questions
                </h2>

                <div className="accordion" id="accordionExample">
                  <div className="accordion-item">
                    <h2 className="accordion-header" id="headingOne">
                      <button
                        className="accordion-button"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseOne"
                        aria-expanded="true"
                        aria-controls="collapseOne"
                      >
                        What is the recommended number of PTE mock tests that I should undertake?
                      </button>
                    </h2>
                    <div
                      id="collapseOne"
                      className="accordion-collapse collapse show"
                      aria-labelledby="headingOne"
                      data-bs-parent="#accordionExample"
                    >
                      <div className="accordion-body">
                      It is recommended to take three complete PTE mock tests.
                      </div>
                    </div>
                  </div>
                  <div className="accordion-item">
                    <h2 className="accordion-header" id="headingTwo">
                      <button
                        className="accordion-button collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseTwo"
                        aria-expanded="false"
                        aria-controls="collapseTwo"
                      >
                        What is the PTE requirement for canada?
                      </button>
                    </h2>
                    <div
                      id="collapseTwo"
                      className="accordion-collapse collapse"
                      aria-labelledby="headingTwo"
                      data-bs-parent="#accordionExample"
                    >
                      <div className="accordion-body">
                      The minimum PTE score for Bachelor's programs, Advanced Diplomas, and Post Graduate Programs is 60, with a minimum band score of 53. Students with an overall score of 56 and each band score of at least 51 have also been granted study permits.
                      </div>
                    </div>
                  </div>
                  <div className="accordion-item">
                    <h2 className="accordion-header" id="headingThree">
                      <button
                        className="accordion-button collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseThree"
                        aria-expanded="false"
                        aria-controls="collapseThree"
                      >
                        What is the duration of a full-length PTE mock test?
                      </button>
                    </h2>
                    <div
                      id="collapseThree"
                      className="accordion-collapse collapse"
                      aria-labelledby="headingThree"
                      data-bs-parent="#accordionExample"
                    >
                      <div className="accordion-body">
                      Around 2 hours. Students can attempt the test in one go or by taking short breaks.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
        </div> 
        <Footer />
      </React.Fragment>
    );
  }
}

export default PteStudyMaterial;
